import api from "@/api/index";

export default {

  sendRequest(link) {
    return api.get(link).then(response => response.data)
  },

  loadChildren(link) {
    return this.sendRequest(link)
  },

  getCountHouses(link) {
    return this.sendRequest(link)
  },

  createReport(link) {
    return this.sendRequest(link)
  },

  loadReport(link) {
    return api.get(link, {responseType: 'blob'}).then(response => ({
        data: response.data,
        filename: response.headers['content-disposition'].match(/filename="([^;\n]+)"/)[1]
      })
    )
  }

}
